import React from "react";
import { Link } from "react-router-dom";
import { kingArt } from "../lib/kingart";

const variants = {
  purple: "bg-purpleK text-white shadow-[0_7px_0_#7A3CB3] hover:shadow-[0_10px_0_#7A3CB3]",
  gold: "bg-goldK text-ink shadow-[0_7px_0_#D4A017] hover:shadow-[0_10px_0_#D4A017]",
  orange: "bg-orangeK text-white shadow-[0_7px_0_#c96a22] hover:shadow-[0_10px_0_#c96a22]",
  teal: "bg-tealK text-white shadow-[0_7px_0_#178f86] hover:shadow-[0_10px_0_#178f86]",
  pink: "bg-pinkK text-white shadow-[0_7px_0_#c23f78] hover:shadow-[0_10px_0_#c23f78]",
  white: "bg-white text-purpleK shadow-[0_7px_0_#e6d6f5] hover:shadow-[0_10px_0_#e6d6f5]",
};

export function Btn({ variant = "purple", as = "button", to, children, className = "", ...rest }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 font-display font-semibold text-lg " +
    "hover:-translate-y-0.5 active:translate-y-1.5 active:shadow-none transition-[transform,box-shadow] duration-150 " +
    `${variants[variant]} ${className}`;
  if (as === "link") return <Link to={to} className={base} {...rest}>{children}</Link>;
  return <button className={base} {...rest}>{children}</button>;
}

export function SectionTitle({ eyebrow, title, sub, className = "", tint = "#9B51E0" }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      {eyebrow && (
        <span className="inline-block mb-3 rounded-full px-4 py-1.5 font-display font-semibold text-sm tracking-wide uppercase" style={{ background: `${tint}1a`, color: tint }}>
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-ink leading-tight">{title}</h2>
      {sub && <p className="mt-4 text-lg text-ink/70 leading-relaxed">{sub}</p>}
    </div>
  );
}

export function PageHeader({ eyebrow, title, sub, tint = "#9B51E0" }) {
  return (
    <header className="relative overflow-hidden dotgrid" style={{ background: `${tint}18` }}>
      <div className="max-w-6xl mx-auto px-6 pt-28 pb-16 md:pt-32 md:pb-24 text-center">
        <span className="inline-block mb-4 rounded-full px-5 py-2 font-display font-semibold text-white text-sm tracking-wide" style={{ background: tint }}>
          {eyebrow}
        </span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-ink">{title}</h1>
        {sub && <p className="mt-5 text-lg md:text-xl text-ink/70 max-w-2xl mx-auto leading-relaxed">{sub}</p>}
      </div>
      <CurvedDivider color="#FFF9F0" />
    </header>
  );
}

// Wavy curved section divider. Place at bottom of a colored section.
export function CurvedDivider({ color = "#FFF9F0", flip = false, className = "" }) {
  return (
    <svg
      className={`absolute inset-x-0 w-full pointer-events-none ${flip ? "top-0 rotate-180" : "bottom-0"} ${className}`}
      viewBox="0 0 1440 90" preserveAspectRatio="none" style={{ height: "70px", color }} fill="currentColor" aria-hidden>
      <path d="M0,45 C240,100 480,0 720,35 C960,70 1200,5 1440,45 L1440,90 L0,90 Z" />
    </svg>
  );
}

// Gentle full-screen loader shown while a lazy route chunk loads.
export function KingdomLoader() {
  return (
    <div className="min-h-[60vh] grid place-items-center bg-cream" data-testid="kingdom-loader" aria-label="Loading">
      <div className="flex flex-col items-center gap-4">
        <img src={kingArt("walking-backpack")} alt="" aria-hidden
          className="h-28 w-auto object-contain animate-bob drop-shadow-[0_12px_18px_rgba(74,59,82,0.25)]" />
        <span className="font-display font-semibold text-ink/60 animate-pulse">Opening the Kingdom…</span>
      </div>
    </div>
  );
}
